import gql from 'graphql-tag';

export default gql`
subscription {
    onDeleteAdvertiser {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Roles/DeleteSubscription.js